export const SUPPORT_PHONE_NUMBER = "+14247440155";
export const SUPPORT_TEL = `tel:${SUPPORT_PHONE_NUMBER}`;
